import { render, staticRenderFns } from "./kyc-summary.vue?vue&type=template&id=56f596f2&"
import script from "./kyc-summary.vue?vue&type=script&lang=js&"
export * from "./kyc-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports